import { useLayoutEffect } from 'react';
import {
	MOBILE_ISLAND_BODY_CLASS,
	MOBILE_ISLAND_CONTEXTUAL_CLASS,
	MOBILE_ISLAND_SEARCH_FOCUSED_CLASS,
	MOBILE_ISLAND_SEARCH_OPEN_CLASS,
} from './constants';

/** 同步 body 类名：岛启用 / 搜索展开 / 搜索聚焦 / 上下文态 */
export const useMobileIslandDockBodyClasses = ({ contextual = false, searchExpanded = false, searchFocused = false, resetKey }) => {
	useLayoutEffect(() => {
		document.body.classList.add(MOBILE_ISLAND_BODY_CLASS);
		if (contextual) {
			document.body.classList.add(MOBILE_ISLAND_CONTEXTUAL_CLASS);
		}

		return () => {
			document.body.classList.remove(MOBILE_ISLAND_BODY_CLASS);
			document.body.classList.remove(MOBILE_ISLAND_CONTEXTUAL_CLASS);
			document.body.classList.remove(MOBILE_ISLAND_SEARCH_OPEN_CLASS);
			document.body.classList.remove(MOBILE_ISLAND_SEARCH_FOCUSED_CLASS);
		};
	}, [contextual]);

	useLayoutEffect(() => {
		document.body.classList.toggle(MOBILE_ISLAND_SEARCH_OPEN_CLASS, searchExpanded);
	}, [searchExpanded]);

	useLayoutEffect(() => {
		document.body.classList.toggle(MOBILE_ISLAND_SEARCH_FOCUSED_CLASS, searchExpanded && searchFocused);
	}, [searchExpanded, searchFocused]);

	useLayoutEffect(() => {
		if (!resetKey) {
			return undefined;
		}

		document.body.classList.remove(MOBILE_ISLAND_SEARCH_OPEN_CLASS);
		document.body.classList.remove(MOBILE_ISLAND_SEARCH_FOCUSED_CLASS);
	}, [resetKey]);
};
